import { postCreateLottery } from '../api/postCreateLottery';
import { setGetListLottery } from './setGetListLottery';

const setPostCreateLottery = (params) => {
    return async (dispatch, getState) => {
        try {
            await postCreateLottery(params);
            dispatch(setGetListLottery({
                page: 1,
                rowsPerPage: 10
            }))
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setPostCreateLottery
}